import { ArrowDownAZ } from 'lucide-react';
import { Button } from '@/components/ui/button';

type CaptionSortButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

// DV-3537: Internal Post-Processing's Caption Sort, in the control bar's
// trailing slot where every other role sees the service pills. Desktop only —
// the slot itself is (AssetsControlBar); below lg the same action is the
// kebab's sub-lg-only Caption Sort item, like Download/Upload.
const CaptionSortButton = ({
  onClick,
  disabled = false
}: CaptionSortButtonProps) => (
  <Button type="button" onClick={onClick} disabled={disabled}>
    <ArrowDownAZ className="h-4 w-4" />
    Caption Sort
  </Button>
);

export default CaptionSortButton;
